import * as React from 'react';

interface ITabcontrollerProps {
  tabs: ITabDetail[];
  onChange: (activeIndex: number, key?: string) => void;
  fontClass?: string;
  hideHash?: boolean;
}

export const Tabcontroller: React.FunctionComponent<ITabcontrollerProps> = (
  props
) => {
  const fontClass = props.fontClass ?? 'font-xs';
  return (
    <React.Fragment>
      <ul
        className={
          'nav tab-underline mb-0 border-bottom  px-4 font-weight-semibold overflow-auto flex-nowrap ' +
          fontClass
        }
        id="activity-tab"
        role="tablist"
      >
        {props.tabs.map((p, index) => {
          const txt = p.text.toLowerCase().replace(/\s/g, '');
          return (
            <li
              onClick={() => {
                props.onChange(index, p.key);
              }}
              className="nav-item mr-4"
              role="presentation"
            >
              <a
                className={
                  'cursor-pointer nav-link position-relative px-0 py-2 text-gray-600 ' +
                  (p.isActive ?? false ? 'active' : ' ')
                }
                // id={txt}
                data-toggle={txt}
                href={props.hideHash ? undefined : '#' + txt}
                role="tab"
                aria-controls={txt}
                aria-selected="true"
              >
                {!p.headerRenderer && (
                  <span className="py-1 d-inline-flex">
                    {p.icon && (
                      <i
                        className={p.icon + ' text-gray-800 font-base mr-2'}
                      ></i>
                    )}
                    {p.text}
                  </span>
                )}
                {p.headerRenderer && p.headerRenderer()}
              </a>
            </li>
          );
        })}
      </ul>
      <div className={'tab-content'} id={'activity-tabContent'}>
        {props.tabs.map((p, index) => {
          const txt = p.text.toLowerCase().replace(/\s/g, '');
          return (
            <div
              className={
                'tab-pane fade ' + (p.isActive ?? false ? 'show active' : '')
              }
              // id={txt}
              role="tabpanel"
              aria-labelledby={txt}
            >
              {p.content}
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

export interface ITabDetail {
  text: string;
  icon?: string;
  isActive?: boolean;
  content: JSX.Element;
  headerRenderer?: () => JSX.Element;
  key?: string;
}
